<template>
  <div class="dashboard-home">
    <BaseContainer>
      <template v-slot:header-title>
        Dashboard
      </template>
      <template v-slot:header-title-description>
        Acompanhe os números da plataforma.
      </template>

      <div class="app-align-items-center mb-4">
        <v-autocomplete
          id="qa-id-name-program-list"
          v-model="selectedProgram"
          :items="programList"
          return-object
          item-value="id"
          item-text="name"
          label="Selecione o programa"
          :rules="[isValid]"
          :disabled="editingDashboard"
          style="max-width: 250px;"
          class="mr-2"
          @change="onChangeProgram"
        />
        <v-autocomplete
          v-if="organizationList.length > 0"
          id="qa-id-name-organization-list"
          v-model="selectedOrganization"
          :items="organizationList"
          return-object
          clearable
          item-value="roleAndTaxnumber"
          item-text="nameAndTaxnumber"
          label="Selecione a organização"
          hint="Filtre por Razão Social ou CNPJ"
          no-data-text="Organização não encontrada"
          persistent-hint
          :rules="[isValid]"
          :disabled="editingDashboard"
          style="max-width: 250px;"
          class="mr-2"
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
              <v-list-item-subtitle>{{ item.tax_number | maskCNPJ }}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </div>
      <BaseDashboard
        v-if="selectedProgram && selectedOrganization"
        :selected-role="programRole"
        :selected-program="selectedProgram"
        selected-configuration-id="dashboard_url_"
        :selected-organization="selectedOrganization"
        @isEditingDashboard="isEditingDashboard"
      />
      <div v-else class="my-12">
        Não há dados para exibir. Utilize os filtros acima para buscar novos dados.
      </div>
    </BaseContainer>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex"
import BaseContainer from '../BaseContainer'
import BaseDashboard from '../BaseDashboard'

export default {
  components: { BaseContainer, BaseDashboard },
  data: () => ({
    selectedProgram: null,
    selectedOrganization: null,
    editingDashboard: false
  }),
  computed: {
    ...mapState({
      allPrograms: (state) => {
        return state.platformProgram.allPrograms
      }
    }),
    programList() {
      return this.allPrograms.filter(
        elem => elem.is_owner || elem.enrollments.findIndex(enrollment => enrollment.status === 'ENROLLED' ) != -1
      )
    },
    hideDashboard(){
      return !this.selectedProgram || (this.organizationList.length > 0 && !this.selectedOrganization)
    },
    organizationList(){
      let orgList = []

      if(this.selectedProgram){

        if(this.selectedProgram.is_owner == true){
          this.addItemList(orgList, 'owner', 'Gestor', '')
        }

        if(this.selectedProgram.enrollments.length > 0){
          this.selectedProgram.enrollments.map((enrollment)=> {
            this.addItemList(orgList, enrollment.role, enrollment.organization.name, enrollment.organization.tax_number)
          })
        }
      }
      return orgList
    },
    programRole(){
      return this.selectedProgram && this.selectedOrganization && this.selectedOrganization.role ? this.selectedOrganization.role : ''
    }
  },
  watch: {
    allPrograms: {
      handler() {
        if(this.selectedProgram){
          this.selectedProgram = this.programList.filter(program => program.initiator === this.selectedProgram.initiator)[0]
        }
      }
    }
  },
  created(){
    this.apiGetAllPrograms()
  },
  methods: {
    ...mapActions(["apiGetAllPrograms"]),
    onChangeProgram(){
      this.selectedOrganization = null
    },
    addItemList(list, role, name, tax_number){
      list.push({
        role,
        name,
        tax_number,
        nameAndTaxnumber: tax_number ? `${name} - ${tax_number}` : name,
        roleAndTaxnumber: tax_number ? `${role} - ${tax_number}` :  `${role} - ${name}`
      })
      return list
    },
    isEditingDashboard(value) {
      this.editingDashboard = value
    }
  }
}
</script>

<style lang="scss">
</style>
